import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as PrizesActions } from 'store/ducks/prizes';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs, Icon } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Pontos', to: '/points' }, { name: 'Premiações', to: '' }],
  };

  componentDidMount() {
    const { location, getPrizesRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getPrizesRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getPrizesRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getPrizesRequest(queryString.parse(location.search).page);
    }
  }

  handleDelete = id => {
    this.props.deletePrizeRequest(id);
  };

  render() {
    const { breadcrumbs } = this.state;
    const { prizes } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Premiações</Page.Title>

        <Panel className="panel-list">
          {!prizes.data.length && prizes.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {prizes.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>objetivo</th>
                    <th>recompensa</th>
                    <th>ativo</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!prizes.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {prizes.data.map((prize, index) => (
                    <tr key={prize.id}>
                      <td>{prize.attributes.goal}</td>
                      <td>{prize.attributes.reward}</td>
                      <td>{prize.attributes.active ? 'sim' : 'não'}</td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-prizes') && (
                          <Link to={`/points/prizes/${prize.id}/edit`} className="button-icon">
                            <Icon name="pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={prizes.page} total={prizes.totals} {...this.props} />

              {Access.hasPermissions('edit-prizes') && (
                <Link className="button-add" to="/points/prizes/create">
                  Adicionar Premiação
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  prizes: state.prizes,
});

const mapActions = dispatch => bindActionCreators(PrizesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
